import React from 'react';

const KpisSection = () => (
  <div className='Stats'>
    <div className='squareStats'>
      <p className='squareStats-number'>128</p>
      <p className='squareStats-title'>Asignaciones totales</p>
    </div>
    <div className='squareStats'>
      <p className='squareStats-number'>5</p>
      <p className='squareStats-title'>Asignaciones planificadas</p>
    </div>
    <div className='squareStats'>
      <p className='squareStats-number'>10</p>
      <p className='squareStats-title'>Asignaciones ejecutadas</p>
    </div>
    <div className='squareStats'>
      <p className='squareStats-number'>+5%</p>
      <p className='squareStats-title'>Comparativa mes pasado</p>
    </div>
  </div>
);

export default KpisSection;



// WEBPACK FOOTER //
// ./src/components/FichaLogistica/Asignaciones/KpisSection.js